import React from 'react';

const CancellationProtectIcon = () => (
  <svg width={44} height={44} viewBox="0 0 44 44" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.413 9.2a.13.13 0 01-.127-.13V4.1l5.096 5.1h-4.969zm9.069 1.18c-.002-.3-.123-.61-.349-.83L31.935.35h-.001a1.186 1.186 0 00-.849-.35H5.53A2.53 2.53 0 003 2.53v19.59h2.403V2.53c0-.07.057-.13.127-.13h24.353v6.67c0 1.39 1.135 2.53 2.53 2.53h6.669v29.87c0 .07-.058.12-.127.12H21.964V44h16.991c1.395 0 2.53-1.14 2.53-2.53V10.4c0-.01-.003-.01-.003-.02z"
      fill="#B20094"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.352 24.89a.833.833 0 00-.157.02l-7.698 2.31a.557.557 0 00-.387.52v8.47c0 1.96 1.633 3.65 3.003 4.72 1.783 1.4 3.85 2.34 5.077 2.73.052.01.106.02.162.02.055 0 .11-.01.161-.02 1.23-.39 3.296-1.33 5.078-2.73 1.37-1.07 3.003-2.76 3.003-4.72v-8.47a.54.54 0 00-.388-.52l-7.699-2.31a.812.812 0 00-.155-.02zm0 2.52l5.801 1.75v7.05c0 .74-.773 1.79-2.069 2.8-1.32 1.04-2.784 1.75-3.732 2.12-.948-.37-2.41-1.08-3.733-2.11-1.295-1.02-2.068-2.07-2.068-2.81v-7.05l5.801-1.75z"
      fill="#B20094"
    />
  </svg>
);

export default CancellationProtectIcon;
